"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropsList = void 0;
const moduleIds_1 = require("root/src/shared/descriptions/modules/moduleIds");
const recordTypes_1 = require("root/src/shared/descriptions/endpoints/recordTypes");
const moduleTypes_1 = require("root/src/shared/constants/moduleTypes");
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
const keys_1 = require("root/src/shared/constants/keys");
const routeIds_1 = require("root/src/shared/descriptions/routes/routeIds");
const dropsBannerHeader_1 = require("root/src/shared/descriptions/modules/dropsBannerHeader");
exports.dropsList = {
    [moduleIds_1.DROPS_LIST_MODULE_ID]: {
        moduleType: 'list',
        hideEmptyTabs: true,
        listType: moduleTypes_1.dropsEventListType,
        listRouteId: routeIds_1.DROP_EVENT_PAGE_ROUTE_ID,
        recordType: recordTypes_1.dropEvent,
        endpointId: [endpointIds_1.GET_DROP_EVENTS],
        pageItemsCount: 8,
        listPayload: (state) => {
            const { dataFilter } = (0, dropsBannerHeader_1.getBannerHeaderEmbeddedFilters)(state);
            return {
                section: keys_1.liveEventsKey,
                pageItemLength: 8,
                dataFilter,
            };
        },
        sortFilterModule: moduleIds_1.DROPS_BANNER_HEADER_MODULE_ID,
    },
};
